export type EnhancedPointCloudDirection = 'all' | 'future' | 'past';
export const defaultCloudDensity = 50;

export class EnhancedCloudSettingsState {
  enabled = false;
  direction: EnhancedPointCloudDirection = 'all';
  frames = 50;
  density = defaultCloudDensity;
}
